import airbridge from 'airbridge-web-sdk-loader';
import {useAtomValue} from 'jotai';
import {useEffect} from 'react';
import {userAtom} from '@/atom';
import {useDeviceId} from '@/hooks';
import {setAirbridgeOnboardingProfile} from '@/utils';

export const AirbridgeInit = () => {
  const user = useAtomValue(userAtom);
  const {deviceId} = useDeviceId();

  useEffect(() => {
    airbridge.init({
      app: `${process.env.REACT_APP_AIRBRIDGE_APP_NAME}`,
      webToken: `${process.env.REACT_APP_AIRBRIDGE_WEB_TOKEN}`,
      userHash: false,
      shareCookieSubdomain: false,
      urlQueryMapping: {
        channel: 'utm_source', // required
        campaign: 'utm_campaign',
        sub_id: 'utm_medium',
        term: 'utm_term',
        ad_group: 'utm_content',
      },
    });
  }, []);

  useEffect(() => {
    if (deviceId) {
      airbridge.setDeviceAlias('device_id', deviceId);
    }
  }, [deviceId]);

  useEffect(() => {
    if (user) {
      airbridge.setUserID(user.id);
      airbridge.setUserEmail(user.email);
      airbridge.setUserPhone(user.cellPhone);

      setAirbridgeOnboardingProfile(user.profile);
    }
  }, [user]);

  return null;
};
